export default function Layout({ children, theme }) {
    let bgColor = '#f3f4f6'
    // if (theme == 'dark') {
    //     bgColor = '#121212 !important'
    // }
    return <div style={{ backgroundColor: bgColor }} className="main-wrapper">{children}</div>;
}